<template>
    <!-- 问题研讨 -->
    <div class="discu-box">
        <div class="title">{{ $t('问题研讨') }}</div>

        <div class="question-box">
            <template v-if="dataList.length > 0">

                <div class="list" v-for="(item, index) in dataList">
                    <div class="info df aic">
                        <div @click="handleOpenavatar(item)" class="df cup">
                            <el-avatar :size="24" :src="item.user_avatar_url" @error="true">
                                <img src="@/assets/images/avatar.png" alt="">
                            </el-avatar>
                        </div>
                        <span class="name">
                          {{ item.user_nick_name }}
<!--                          {{ item.is_expert == 10 ? item.user_name : item.user_nick_name }}-->
                        </span>
<!--                        <div class="moderator-box ml-12 df">-->
<!--                            &lt;!&ndash; 评论 icon-pinglun      点赞 icon-dianzan_kuai  &ndash;&gt;-->
<!--                            <div class="box-1"><span class="iconfont icon-pinglun"></span></div>-->
<!--                            <div class="box-2">{{ $t('版主点赞') }}</div>-->
<!--                        </div>-->
                    </div>

                    <!-- 是否是精华帖 -->
                
<!--                    <div class="essence-box">-->
<!--                        <img src="@/assets/images/essence-zh.png" alt="">-->
<!--                    </div>-->
                    <div class="desc" v-html="item.taqa_content">

                    </div>

                  <div class="like-box df aic jcsb">
                    <div class="pl-36">
                      <span class="c-6 fs-14">{{ item.create_time }}</span>
                    </div>
                    <div class="df jcfe">
<!--                      <el-button type="text" class="df aic" v-throttle="1000"-->
<!--                                 :class="{ 'have_like': item.data_have_be_like == 1 }">-->
<!--                        <span class="iconfont icon-jiangbei"></span>-->
<!--                        <span class="hava-text">-->
<!--                                {{ $t('置为精华评论') }}-->
<!--                            </span>-->
<!--                      </el-button>-->

                      <el-button type="text" class="df aic" v-throttle="1000" @click="handleReplyPer(item)">
                        <span class="iconfont fs-15">&#xe60b;</span>{{ $t('回复') }}</el-button>
                      <el-button type="text" class="df aic" v-throttle="1000"
                                 :class="{ 'have_like': item.have_like == 10 }" :loading="item.is_loading" @click="handleactQuestionLike(item)">
                        <span class="iconfont">{{ item.have_like == 10 ? '&#xe656;' : '&#xe61b;' }}</span>
                        <span class="hava-text">
                                {{ item.taqa_likes ? item.taqa_likes : $t('点赞') }}
                            </span>
                      </el-button>
                      <el-button v-if="userinfo.user_id == item.user_id" type="text" class="df aic" v-throttle="1000" :loading="item.delete_loading" @click="handleDelete(item)">
                        <span class="iconfont fs-15">&#xe622;</span>{{ $t('删除') }}
                      </el-button>
                    </div>
                  </div>

                    <div v-if="item.children.length > 0" style="padding-left:40px;">
                        <reply-list v-for="(items, indexs) in item.children" :key="indexs" :item="items" :userinfo="userinfo"
                            :handleReplyPer="handleReplyPer" :handleactQuestionLike="handleactQuestionLike" :handleDelete="handleDelete" />
                    </div>
                    <!--               
                    <template v-if="item.children.length > 0">
                        <div class="list" v-for="(items, indexs) in item.children" :key="indexs">
                            <div class="info df aic">
                                <el-avatar :size="24" :src="items.user_avatar_url"></el-avatar>
                                <span class="name">{{ items.user_nick_name }}</span>
                            </div>
                            <div class="desc">
                                {{ items.taqa_content }}
                            </div>
                            <div class="like-box df jcfe">
                                <el-button type="text" class="df aic" @click="handleReplyPer(items)"><img
                                        src="@/assets/images/path1.png" alt="">回复</el-button>
                                <el-button type="text" class="df aic" :class="{ 'have_like': items.have_like == 10 }"
                                    @click="handleactQuestionLike(items)">
                                    <span class="iconfont">{{ items.have_like == 10 ? '&#xe656;' : '&#xe61b;'
                                        }}</span>点赞
                                </el-button>
                            </div>
                        </div>
                    </template> -->

                </div>

            </template>
            <div class="no_news df fdc jcc aic" v-else>
                <img src="@/assets/images/no_news.png" alt="">
                <p>{{ $t('暂无消息') }}</p>
            </div>
        </div>
        <div>
            <div class="reply-box df aic">
                <el-input 
                    ref="textareaRef"
                    type="textarea" 
                    :autosize="{ minRows: 2, maxRows: 10 }" 
                    :placeholder="$t('请输入内容')"
                    v-model="textarea"
                >
                </el-input>
                
                <!-- 添加链接插入按钮 -->
                <el-tooltip :content="$t('插入链接')" placement="top">
                    <el-button type="text" class="ml-20 custom-link-btn" @click="openLinkDialog(1)">
                    <i class="el-icon-link"></i>
                    </el-button>
                </el-tooltip>
                
                <el-button 
                    type="text" 
                    class="ml-20" 
                    @click="handleReplyLink" 
                    :loading="replyLoading"
                >
                    <img src="@/assets/images/public_send.png" alt="">
                </el-button>
            </div>
        </div>
        <!-- <div class="reply-box df aic">
            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 10 }" :placeholder="$t('请输入内容')"
                v-model="textarea">
            </el-input>
            <el-button type="text" class="ml-20" @click="handleReply">
                <img src="@/assets/images/public_send.png" alt=""></el-button>
        </div> -->

        <el-dialog :title="$t('回复')" :visible.sync="dialogVisible" width="570px">

            <!-- <div class="df reply-person">
                <span class="fn mr-16 c-9 fs-14">{{ $t('回复') }}</span>
                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 10 }" :placeholder="$t('请输入您的回复')"
                    v-model="textareaper"></el-input>
            </div> -->
            <div class="df reply-person">
                <span class="fn mr-16 c-9 fs-14">{{ $t('回复') }}</span>
                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 10 }" :placeholder="$t('请输入您的回复')" ref="textareaRefDialog"
                    v-model="textareaper"></el-input>
                <!-- 添加链接插入按钮 -->
                <el-tooltip :content="$t('插入链接')" placement="top">
                    <el-button type="text" class="ml-20 custom-link-btn"  @click="openLinkDialog(2)">
                    <i class="el-icon-link"></i>
                    </el-button>
                </el-tooltip>
            </div>
<!--          <div class="languige-text harmonyos-text mt-24" v-if="userinfo.user_expert == 10">-->
<!--            {{ $t('以实名身份发布') }}-->
<!--            <el-tooltip :content="$t('以专家身份实名评论后页面会同步展示实名信息')" placement="bottom-start" effect="light">-->
<!--              <span class="iconfont">&#xe677;</span>-->
<!--            </el-tooltip>-->
<!--            <el-checkbox-group v-model="is_expert" style="display: inline-block;" class="ml-23">-->
<!--              <el-checkbox :key="10" :label="10">{{ $t('是') }}</el-checkbox>-->
<!--            </el-checkbox-group>-->
<!--          </div>-->

            <span slot="footer" class="dialog-footer">
                <el-button @click="closeReplyDialog" class="btn1">{{ $t('取消') }}</el-button>
                <el-button type="primary" class="btn2" @click="handelSubPerLink">{{ $t('确定') }}</el-button>
            </span>
        </el-dialog>
        <el-dialog
            :visible.sync="dialogVisibleLink"
            :title="$t('请输入链接地址')"
            @close="handleCloseLink"
            >
            <el-input v-model="linkUrl" :placeholder="$t('请输入链接地址')" />
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisibleLink = false">{{ $t('取消') }}</el-button>
                <el-button type="primary" @click="insertLink">{{ $t('确认') }}</el-button>
            </span>
        </el-dialog>

        <!-- 个人信息 -->
        <avatarTop ref="avatarDialog" @post-submitted="handleAvatarSubmitted" :id="ac_id" />

    </div>
</template>

<script>
import {getactQuestion, getactQuestionLike, setactQuestionAdd, getactQuestionDelete} from "@api/active";
import { getMyInfo, setuserfollowAdd } from "@api/home";
import replyList from "./replyList.vue";
import {deletePostAns} from "@api/post";
import { markdownToHtml,isValidUrl } from '@/utils/markdownUtils';

export default {
    components: {
        replyList
    },
    props: {
        id: {
            type: [String, Number],
            required: true
        },
        data: {
            type: Array,
            default: []
        },
    },
    data() {
        return {
            dialogVisible: false,  //回复弹框
            dataList: [],
            userinfo: [],
            textarea: '',
            textareaper: '',  //回复别人的评论
            is_expert: [],  //回复别人的评论
            personObj: {},

            ac_id: 0,
            replyLoading: false,
            previewHtml: '',
            dialogVisibleLink: false,  // 控制 Dialog 显示
            linkUrl: '',           // 存储用户输入的链接
            linkType:1,
            linkToContent:"",

        }
    },
    watch: {
        data: {
            handler(newData) {
              this.dataList = this.data;
            },
            deep: true, // 如果需要深度监听数组中的对象变化，可以设置为 true
            immediate: true // 如果希望在组件创建时立即执行一次 handler
        },
      'userinfo.user_expert'(newValue) {
        if (newValue === 10) {
          this.is_expert = [10];  // 默认选中
        } else if (newValue !== 10) {
          this.is_expert = [20];  // 如果不是 10，接口传值为 20
        }
      },
    },
  created() {
    // 初始化时判断 userinfo.user_expert 的值
    if (this.userinfo.user_expert === 10) {
      this.is_expert = [10];  // 默认选中 10
    } else {
      this.is_expert = [20];  // 默认选中 20
    }
  },

    mounted() {
        this.dataList = this.data;
        this.getCurrUserData();

    },
    methods: {
      closeReplyDialog() {
        this.dialogVisible = false;
        setTimeout(() => {
          this.textareaper = '';
        }, 200);
      },

        errorHandler() {
            return true
        },
        async getCurrUserData() {
            let res = await getMyInfo();
            if (res.status == 200) {
                this.userinfo = res.data;
            }
        },

        handleOpenavatar(item) {
            if (item.user_id == 0 || item.user_id == null || item.user_nick_name == 0 || item.user_nick_name == null) {
                return false;
            }
            this.ac_id = item.user_id;
            this.$refs.avatarDialog.openModal();
            // 
        },
        // 个人信息谈款
        async handleAvatarSubmitted(id) {

            let res = await setuserfollowAdd({ tuf_be_follow_user_id: id });
            if (res.status == 200) {
                this.$message.success(res.msg);

            }

        },

        async getData() {
            let res = await getactQuestion({ id: this.id });
            this.dataList = res.data;
        },

        // 电站
        async handleactQuestionLike(item) {
            this.$nextTick(() => {
              item.is_loading = true;
            })
            let res = await getactQuestionLike({ taqa_id: item.taqa_id });
            this.getData();
        },
      //删除
        async handleDelete(item) {
            this.$nextTick(() => {
              item.delete_loading = true;
            })
            let res = await getactQuestionDelete({ taqa_id: item.taqa_id });
            if (res.status == 200) {
              this.$message({
                message: res.msg,
                type: 'success',
                customClass: 'mt-60' // 添加自定义类
              });
            }
            await this.getData();

        },


        handleReply() {
            let content = (this.linkToContent.length > 0)?this.linkToContent:this.textarea;
            let obj = { ta_id: this.id, taqa_content: content };
            this.setactquestionAdd(obj);
            this.textarea = '';
        },

        handelSubPer() {
            let content = (this.linkToContent.length > 0)?this.linkToContent:this.textareaper;
            this.is_expert = this.is_expert.length > 0 ? this.is_expert[0] : 20;
            let sub_pid = this.personObj.taqa_id;
            if (this.personObj.taqa_pid > 0) sub_pid = this.personObj.taqa_pid;
            let obj = { ta_id: this.id, taqa_content: content, to_user_id: this.personObj.user_id, taqa_pid: sub_pid, is_expert: this.is_expert };
            this.setactquestionAdd(obj);
            setTimeout(() => {
                this.dialogVisible = false;
                this.textareaper = '';
                this.is_expert = [10];
            }, 200);
        },

        // 回复评论
        handleReplyPer(item) {
            this.dialogVisible = true;
            this.personObj = item;

        },
        // 评论
        async setactquestionAdd(obj) {
            let res = await setactQuestionAdd(obj);

            if (res.status == 200) {
                this.$message({
                    message: res.data.msg,
                    type: 'success',
                    customClass: 'mt-60' // 添加自定义类
                });
            }
            this.getData();
        },
        openLinkDialog(type) {
            this.linkUrl = '';
            this.linkType = type; // 保存类型
            this.dialogVisibleLink = true; // 打开 Dialog
        },
        insertLink(type) {
            const url = this.linkUrl;
            if (url == '') {
                this.$message.warning(this.$t('请输入链接地址'));
                return;
            }
            if (url) {
                if (!isValidUrl(url)) {
                    this.$message.warning(this.$t('请输入正确的链接地址'));
                    return;
                }
                // 自动提取域名作为显示文本
                try {
                const urlObj = new URL(url);
                } catch (e) {
                // 不是完整URL则保持原样
                }
                // 插入Markdown格式链接
                const markdownLink = `${url}`;
                if(this.linkType == 1){
                    this.textarea = this.insertAtCursor(this.textarea, markdownLink,this.linkType);
                }else{
                    this.textareaper = this.insertAtCursor(this.textareaper, markdownLink,this.linkType);
                }
                
            }
        },
        
        // 在光标位置插入文本
        insertAtCursor(text, insertText, type) {
            // 获取正确的输入组件
            const inputComponent = type === 1 
                ? this.$refs.textareaRef 
                : this.$refs.textareaRefDialog;
            
            // 获取原生 textarea 元素
            let textarea = null;
            if (inputComponent && inputComponent.$refs && inputComponent.$refs.textarea) {
                textarea = inputComponent.$refs.textarea;
            }
            // 如果没有获取到 textarea，直接返回原始文本
            if (!textarea) {
                console.error("无法获取 textarea 元素");
                return text;
            }
            const start = textarea.selectionStart;
            const end = textarea.selectionEnd;
            const insertTextLink = ` ${insertText} `;
            // 更新文本
            const newText = text.substring(0, start) + insertTextLink + text.substring(end);
            // 更新光标位置
            this.$nextTick(() => {
                textarea.selectionStart = start + insertTextLink.length;
                textarea.selectionEnd = start + insertTextLink.length;
                textarea.focus();
            });
            this.linkUrl = '';
            this.dialogVisibleLink = false;
            return newText;
        },
        async handleReplyLink() {
            if (!this.textarea.trim()) {
                this.$message.warning(this.$t('请输入内容'));
                return;
            }
            this.replyLoading = true;
            try {
                // 生成预览
                this.previewHtml = markdownToHtml(this.textarea);

                // console.log(this.previewHtml)
                // return false;
                this.linkToContent = this.previewHtml;
                // this.textarea = this.previewHtml
                this.handleReply()
                this.previewHtml = '';
            } catch (error) {
                console.error('回复失败:', error);
                this.$message.error(error.message || this.$t('操作失败'));
            } finally {
                this.replyLoading = false;
            }
        },
        async handelSubPerLink() {
            if (!this.textareaper.trim()) {
                this.$message.warning(this.$t('请输入内容'));
                return;
            }
            this.replyLoading = true;
            try {
                // 生成预览
                this.previewHtml = markdownToHtml(this.textareaper);

                // console.log(this.previewHtml)
                // return false;
                this.linkToContent = this.previewHtml;
                // this.textareaper = this.previewHtml
                this.handelSubPer()
                this.previewHtml = '';
            } catch (error) {
                console.error('回复失败:', error);
                this.$message.error(error.message || this.$t('操作失败'));
            } finally {
                this.replyLoading = false;
            }
        },
        handleCloseLink(){
            this.dialogVisibleLink = false; // 打开 Dialog 
        }
    }
}
</script>


<style lang="scss" scoped>
.essence-box {
    position: absolute;
    right: 24px;
    top: -10px;
}

.moderator-box {
    height: 23px;
    line-height: 22px;

    .box-1 {
        // 背景渐变FFA547
        background: linear-gradient(180deg, #FF8B29 0%, #FFA547 100%);
        // background: #FF8E2D;
        padding: 0 16px 0 6px;
        border-radius: 8px 0 0 0;

        .iconfont {
            font-size: 14px;
            position: relative;
            top: -1px;
            color: #ffffff;
        }
    }

    .box-2 {
        background: #FAEAD7;
        position: relative;
        left: -10px;
        color: #FF8E2D;
        font-size: 12px;
        padding: 0 10px;
        border-radius: 12px 0 8px 0;
        border-left: 1px solid #ffffff;
    }
}

.list {
    margin-top: 16px;
    position: relative;

    .info {
        color: rgb(25, 25, 25);
        font-size: 16px;
        font-weight: 400;
        line-height: 22px;

        .name {
            margin-left: 12px;
            font-family: "MicrosoftYaHeiSemibold";
        }
    }

    .desc {
        margin-left: 36px;
        color: rgb(25, 25, 25);
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        margin-top: 14px;
        ::v-deep() {
            a {
                color: #00e;
            }
        }
    }

    .like-box {
        margin-top: 8px;

        .hava-text {
            min-width: 28px;
            display: inline-block;
            text-align: left;
        }

        button {
            color: rgb(174, 174, 174);
            font-size: 14px;
            font-weight: 400;
            line-height: 22px;
            padding: 0 8px;

            &.have_like {
                color: rgb(216, 15, 5);
                ;
            }

            img,
            .iconfont {
                width: 16px;
                margin-right: 8px;
            }

            &:hover {
                color: rgb(216, 15, 5);
                ;

            }
        }

        .el-button+.el-button {
            margin-left: 0;
        }
    }
}

::v-deep() {
    .el-dialog__body {
        padding: 12px 20px 16px;
    }

    .el-dialog {
        border-radius: 8px;
    }

    .dialog-footer {

        .btn1,
        .btn2 {
            min-width: 75px;
            height: 36px;
            border-radius: 30px;
            padding: 0 16px;
        }

        .btn1 {
            background-color: #ffffff;
            border: 1px solid #ededed;
        }

        .btn2 {
            background-color: #D64F31;
            border: none;
        }

        .el-button+.el-button {
            margin-left: 24px;
        }
    }

}

.reply-person {
    background-color: #F8F8F8;
    padding: 16px;
    border-radius: 4px;

    ::v-deep() {
        .el-textarea__inner {
            border: none;
            padding: 0;
            background-color: transparent;
        }
    }
}

.reply-box {
    min-height: 88px;
    border: 0.5px solid rgb(201, 201, 201);
    border-radius: 8px;
    margin-top: 14px;
    margin-left: 36px;
    padding: 8px 20px 8px 12px;

    ::v-deep() {
        el-textarea {
            height: 100%;

        }

        .el-textarea__inner {
            border: none;
            min-height: 72px !important;

            &::-webkit-scrollbar {
                width: 0;
            }
        }
    }
}

.question-box {
    margin-top: 24px;

    // min-height: 310px;

    .no_news {
        height: 310px;

        p {
            color: rgb(119, 119, 119);

            font-size: 14px;
            font-weight: 400;
            line-height: 24px;
            margin-top: 4px;
        }
    }

}

.discu-box {
    padding-top: 40px;
    padding-bottom: 80px;

    .title {
        color: rgb(25, 25, 25);
        font-size: 20px;
        font-weight: 400;
        line-height: 30px;
        font-family: "MicrosoftYaHeiSemibold";
    }
}
.reply-box {
  margin-top: 20px;
  align-items: flex-start; /* 顶部对齐 */
}

.preview-box {
  margin-top: 15px;
  padding: 15px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background-color: #fafafa;
}

.content-link {
  color: #409eff;
  text-decoration: none;
  border-bottom: 1px dashed #409eff;
  margin: 0 2px;
}
.content-link:hover {
  color: #66b1ff;
  border-bottom-style: solid;
}
/* 在组件样式部分添加 */
.custom-link-btn  {
    font-size: 18px !important;
}

/* 或者更精确的选择器 */
.custom-link-btn > i {
    font-size: 18px !important;
}
</style>